import { render, staticRenderFns } from "./Ppn.vue?vue&type=template&id=74575a77&scoped=true"
import script from "./Ppn.vue?vue&type=script&lang=js"
export * from "./Ppn.vue?vue&type=script&lang=js"
import style0 from "./Ppn.vue?vue&type=style&index=0&id=74575a77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74575a77",
  null
  
)

export default component.exports